module.exports = __webpack_public_path__ + "img/GrinseKeks.b8806682.jpg";